(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9314],{

/***/ 19314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_HeroWrapper; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
// EXTERNAL MODULE: ./node_modules/.pnpm/clsx@1.1.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(51626);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
// EXTERNAL MODULE: ./components/global/Grid/index.tsx + 2 modules
var Grid = __webpack_require__(232);
// EXTERNAL MODULE: ./lib/constants.tsx
var constants = __webpack_require__(52375);
// EXTERNAL MODULE: ./lib/hooks/randomNumber.ts
var randomNumber = __webpack_require__(79245);
// EXTERNAL MODULE: ./components/cms/Hero/Hero.module.scss
var Hero_module = __webpack_require__(85952);
var Hero_module_default = /*#__PURE__*/__webpack_require__.n(Hero_module);
// EXTERNAL MODULE: ./components/cms/Hero/HeroImage.module.scss
var HeroImage_module = __webpack_require__(49011);
var HeroImage_module_default = /*#__PURE__*/__webpack_require__.n(HeroImage_module);
;// CONCATENATED MODULE: ./components/cms/Hero/HeroImage.tsx




var HeroImage = function(param) {
    var blok = param.blok, eager = param.eager;
    var image = blok.image, height = blok.height, width = blok.width, layout = blok.layout, mobileWidth = blok.mobileWidth, mobileHeight = blok.mobileHeight, mobileLayout = blok.mobileLayout, fitToContent = blok.fitToContent;
    var ref = (0,react.useState)(null), filePath1 = ref[0], setFilePath = ref[1];
    var ref1 = (0,react.useState)(null), mobileOptimisation = ref1[0], setMobileOptimisation = ref1[1];
    var imageIsSVG = image.filename.endsWith(".svg");
    var hasMobileLayout = !!(mobileLayout && (mobileWidth || mobileHeight));
    var inDev = "production" === "development";
    var host = "".concat(constants/* SITE_URL */._O, "cdn/");
    var desktopImagePath = imageIsSVG ? image.filename : image.filename + "/m/2900x0/filters:quality(".concat(constants/* STORYBLOK_IMAGE_QUALITY */.We, ")");
    // Fix image src hydration issue
    (0,react.useEffect)(function() {
        if (!image.filename) return;
        var filePath = image.filename;
        if (!inDev) {
            filePath = image.filename.replace("https://a.storyblok.com/", host);
        }
        setFilePath(filePath);
        setMobileOptimisation(imageIsSVG ? filePath : filePath + "/m/767x0/filters:quality(".concat(constants/* STORYBLOK_IMAGE_QUALITY */.We, ")"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        image
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            "--img-width": width,
            "--img-height": height
        },
        className: [
            (HeroImage_module_default()).container,
            fitToContent && (HeroImage_module_default()).fitToContent
        ].join(" "),
        children: hasMobileLayout ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: [
                        (HeroImage_module_default()).image,
                        (HeroImage_module_default()).desktop,
                        (HeroImage_module_default())[layout]
                    ].join(" "),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: filePath1,
                        alt: image.alt,
                        loading: eager ? "eager" : "lazy",
                        /*
              // @ts-ignore */ fetchPriority: eager ? "high" : "low"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        "--img-width": mobileWidth,
                        "--img-height": mobileHeight
                    },
                    className: [
                        (HeroImage_module_default()).image,
                        (HeroImage_module_default()).mobile,
                        (HeroImage_module_default())[mobileLayout]
                    ].join(" "),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: mobileOptimisation,
                        alt: image.alt,
                        loading: eager ? "eager" : "lazy",
                        /*
              // @ts-ignore */ fetchPriority: eager ? "high" : "low"
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: [
                (HeroImage_module_default()).image,
                (HeroImage_module_default())[layout]
            ].join(" "),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: desktopImagePath,
                alt: image.alt,
                loading: eager ? "eager" : "lazy",
                /*
            // @ts-ignore */ fetchPriority: eager ? "high" : "low"
            })
        })
    });
};
/* harmony default export */ var Hero_HeroImage = (HeroImage);

;// CONCATENATED MODULE: ./components/cms/Hero/Hero.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}








var chooseRandom = function(list, keyNumber) {
    if (!list || (list === null || list === void 0 ? void 0 : list.length) === 0) return;
    var ran = keyNumber;
    return list[ran];
};
var Hero = function(param) {
    var title = param.title, subtitle = param.subtitle, footer = param.footer, footerMargin = param.footerMargin, topBorder = param.topBorder, bottomBorder = param.bottomBorder, _topGradient = param.topGradient, topGradient = _topGradient === void 0 ? false : _topGradient, _bottomGradient = param.bottomGradient, bottomGradient = _bottomGradient === void 0 ? false : _bottomGradient, backgroundColor = param.backgroundColor, backgroundColorPreset = param.backgroundColorPreset, html = param.html, css = param.css, sizeImage = param.sizeImage, variant = param.variant, _eager = param.eager, eager = _eager === void 0 ? true : _eager, backgroundDesktop = param.backgroundDesktop, backgroundTablet = param.backgroundTablet, backgroundMobile = param.backgroundMobile, _images = param.images, images = _images === void 0 ? [] : _images;
    var keyNumber = (0,randomNumber/* useRandomNumber */.H)(images.length);
    var randomImage = chooseRandom(images, keyNumber);
    var backgroundColorStyle = backgroundColor ? backgroundColor : backgroundColorPreset;
    var host = "".concat(constants/* SITE_URL */._O, "cdn/");
    var imageIsSVG = function(image) {
        return image.endsWith(".svg");
    };
    var imagePath = function(image, size) {
        return imageIsSVG(image) ? image.replace("https://a.storyblok.com/", host) : image.replace("https://a.storyblok.com/", host) + "/m/".concat(size, "x0/filters:quality(100)");
    };
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            backgroundColor: backgroundColorStyle ? backgroundColorStyle : "transparent"
        },
        className: (0,clsx_m/* default */.Z)((Hero_module_default()).container, (Hero_module_default())[variant]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)((Hero_module_default()).heroLayer),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)((Hero_module_default()).hero),
                    children: [
                        topBorder && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid */.r, {
                            rowPadding: "0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Column */.s, {
                                sm: 12,
                                md: 12,
                                lg: 12,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (0,clsx_m/* default */.Z)(topBorder && (Hero_module_default())["border-".concat(topBorder)])
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Hero_module_default()).heroContent,
                            children: [
                                title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Hero_module_default()).title,
                                    children: title
                                }),
                                subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Hero_module_default()).subtitle,
                                    children: subtitle
                                }),
                                html && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: "".concat(html)
                                    }
                                }),
                                css && /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                                    dangerouslySetInnerHTML: {
                                        __html: "".concat(css)
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Grid */.r, {
                            rowPadding: "0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Column */.s, {
                                sm: 12,
                                md: 12,
                                lg: 12,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (0,clsx_m/* default */.Z)(bottomBorder && (Hero_module_default())["border-".concat(bottomBorder)])
                                    }),
                                    footer && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Hero_module_default()).footer,
                                        children: footer
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)((Hero_module_default()).imageLayer, (_obj = {}, _defineProperty(_obj, (Hero_module_default()).bottomGradient, bottomGradient), _defineProperty(_obj, (Hero_module_default()).topGradient, topGradient), _defineProperty(_obj, (Hero_module_default()).imageLayerFullWidth, sizeImage === "full-width"), _defineProperty(_obj, (Hero_module_default()).imageLayerFill, sizeImage === "fill-hero"), _obj)),
                children: [
                    randomImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero_HeroImage, {
                        blok: randomImage,
                        eager: eager
                    }),
                    (backgroundDesktop === null || backgroundDesktop === void 0 ? void 0 : backgroundDesktop.filename) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                srcSet: imagePath(backgroundDesktop === null || backgroundDesktop === void 0 ? void 0 : backgroundDesktop.filename, 2500),
                                media: "(min-width: 1024px)"
                            }),
                            (backgroundTablet === null || backgroundTablet === void 0 ? void 0 : backgroundTablet.filename) && /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                srcSet: imagePath(backgroundTablet === null || backgroundTablet === void 0 ? void 0 : backgroundTablet.filename, 1800),
                                media: "(max-width: 1023px)"
                            }),
                            (backgroundMobile === null || backgroundMobile === void 0 ? void 0 : backgroundMobile.filename) && /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                srcSet: imagePath(backgroundMobile === null || backgroundMobile === void 0 ? void 0 : backgroundMobile.filename, 1300),
                                media: "(max-width: 767px)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: imagePath(backgroundDesktop === null || backgroundDesktop === void 0 ? void 0 : backgroundDesktop.filename, 1300),
                                alt: backgroundDesktop === null || backgroundDesktop === void 0 ? void 0 : backgroundDesktop.alt,
                                loading: eager ? "eager" : "lazy",
                                /*
              // @ts-ignore */ fetchPriority: eager ? "high" : "low"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Hero_Hero = (Hero);

;// CONCATENATED MODULE: ./components/cms/Hero/index.tsx

/* harmony default export */ var cms_Hero = (Hero_Hero);

// EXTERNAL MODULE: ./storyblok/components/DynamicComponent.tsx + 1 modules
var DynamicComponent = __webpack_require__(79426);
;// CONCATENATED MODULE: ./storyblok/components/HeroWrapper.tsx



var HeroWrapper = function(param) {
    var blok1 = param.blok;
    var title = blok1.title, subtitle = blok1.subtitle, footer = blok1.footer, footerMargin = blok1.footerMargin, topBorder = blok1.topBorder, bottomBorder = blok1.bottomBorder, topGradient = blok1.topGradient, bottomGradient = blok1.bottomGradient, backgroundDesktop = blok1.backgroundDesktop, backgroundTablet = blok1.backgroundTablet, backgroundMobile = blok1.backgroundMobile, backgroundColor = blok1.backgroundColor, backgroundColorPreset = blok1.backgroundColorPreset, sizeImage = blok1.sizeImage, images = blok1.images, html = blok1.html, css = blok1.css, variant = blok1.variant, eager = blok1.eager;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(cms_Hero, {
        title: title[0] && /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicComponent/* default */.Z, {
            blok: title[0]
        }),
        subtitle: subtitle[0] && /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicComponent/* default */.Z, {
            blok: subtitle[0]
        }),
        footer: footer && footer.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: footer.map(function(blok) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicComponent/* default */.Z, {
                    blok: blok
                }, blok._uid);
            })
        }),
        footerMargin: footerMargin,
        backgroundDesktop: backgroundDesktop,
        backgroundTablet: backgroundTablet,
        backgroundMobile: backgroundMobile,
        backgroundColor: backgroundColor,
        backgroundColorPreset: backgroundColorPreset,
        topBorder: topBorder,
        bottomBorder: bottomBorder,
        topGradient: topGradient,
        bottomGradient: bottomGradient,
        html: html,
        css: css,
        sizeImage: sizeImage,
        variant: variant,
        eager: eager,
        images: images
    });
};
/* harmony default export */ var components_HeroWrapper = (HeroWrapper);


/***/ }),

/***/ 85952:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Hero_container__pXV8A","imageLayer":"Hero_imageLayer__SVJ2i","imageLayerFullWidth":"Hero_imageLayerFullWidth__WhJFJ","imageLayerFill":"Hero_imageLayerFill__mE2B7","topGradient":"Hero_topGradient__fhevj","bottomGradient":"Hero_bottomGradient__z_hE0","heroLayer":"Hero_heroLayer__AWS6n","hero":"Hero_hero__AS9TA","heroContent":"Hero_heroContent__bXhCh","title":"Hero_title__kCh1x","subtitle":"Hero_subtitle__D0CrG","footer":"Hero_footer__376Wq","border-black":"Hero_border-black__UJO_T","border-grey":"Hero_border-grey__PFU6C","border-white":"Hero_border-white__kSfrL"};

/***/ }),

/***/ 49011:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"HeroImage_container__hXyZc","image":"HeroImage_image__KARbw","width":"HeroImage_width__1Md40","height":"HeroImage_height__PWs2N","fill":"HeroImage_fill__GCvVZ","contain":"HeroImage_contain__DibDR","mobile":"HeroImage_mobile__GEAtl","desktop":"HeroImage_desktop__HnPoz","fitToContent":"HeroImage_fitToContent__R6RrM"};

/***/ })

}]);